<template>
    <div class="h-100 d-flex">
        <div id="navbarNavAltMarkup" class="col-md-2 sidenav">
            <div class="sidebar">
                <template v-for="panel in getRegisteredSystemMenus()">
                    <div class="nav-item nav-link"  v-on:click="getEventHandler('onClick',panel.onEvents,panel);" :key="panel.label" :class='(activeIndex === panel.label)?"active":"inactive"'>{{panel.tabDisaplyLabel? $t(panel.tabDisaplyLabel): $t(panel.label)}}<span class="sr-only">(current)</span></div>
                </template>
            </div>
        </div>
        <div class="col-md-10 p-0" style="height:calc(100vh - 85px);overflow:auto;overflow-x:hidden">
            <component :is="selectedComponent" v-bind="currentProperties" class="h-100" style="overflow-x:hidden"></component>
        </div>
        <!-- <retrieve-settings v-show="activeIndex == 'global-retrieve'"></retrieve-settings> -->
    </div>
</template>

<script>

import retrieveSettings from "./RetrieveSettings.vue"
import {SystemSettingsMenu} from "../../registry/plugins.js"
import {mapGetters,mapMutations} from "vuex"
import ExternalSystemSettingsPluginLoader from "./SystemSettingsplugin.vue";
import UploadSettings from "./UploadSettings.vue";
import SystemInfo from "./SystemInfo.vue"
// import LicenseSettingsInfo from "./LicenseSttingsInfo.vue"
import ArchiveSettings from "./ArchiveSettings.vue";
import GlobalSettings from "./GlobalSettings.vue";
import Utils from "../../components.utils.js";
import supportSettings from "./SupportSettings.vue";
import accessTokenSettings from "./AccessToken.vue";
import languageSettings from "./languageSettings.vue";
import reportSettings from "./reportSettings.vue";
import ButtonsSettings from "../ButtonsConfiguration/ButtonsSettings.vue";

export default {
    data(){
        return{
            activeIndex: "Retrieve Settings",
            topNavList:[],
            selectedComponent: "retrieve-settings",
            selectedPluginInfo:null
        }
    },
    components: {
        "retrieve-settings": retrieveSettings,
        "external-system-settings-plugin-loader":ExternalSystemSettingsPluginLoader,
        "ingest-settings": UploadSettings,
        "system-info":SystemInfo,
        // "license-settings":LicenseSettingsInfo,
        "archive-settings":ArchiveSettings,
        "support-settings":supportSettings,
        "global-settings":GlobalSettings,
        "access-token-settings":accessTokenSettings,
        "language-settings":languageSettings,
        "reports-settings":reportSettings,
        "buttons-settings":ButtonsSettings
    },
    computed:{
      ...mapGetters("users", ["getLoggedInUserPrivilege",]),
      currentProperties() {
        if (this.selectedComponent === "external-system-settings-plugin-loader") {
            return { pluginInfo : this.selectedPluginInfo};
        }
        else{
            return {}
        }
    },
    },
    methods:{
        changeComponent(comp,label){
          this.activeIndex =  label,
          this.selectedComponent = comp;
        },
        changeComponentToLicenseSettings(){
            this.changeComponent("license-settings","License")
        },
        changeComponentToRetrieveSettings(){
            this.changeComponent("retrieve-settings","Retrieve Settings")
        },
        changeComponentToUploadSettings(){
            this.changeComponent("ingest-settings","Ingest Settings")
        },
        changeComponentToExternalPlugin(label){
            this.changeComponent("external-system-settings-plugin-loader",label)
        },
        changeComponentToSystemInfo(){
            this.changeComponent("system-info","System Info")
        },
        changeComponentToarchive(){
            this.changeComponent("archive-settings","Archive Settings")
        },
        changeComponentToSupport(){
            this.changeComponent("support-settings","Support")
        },
        changeComponentToGlobalSettings(){
            this.changeComponent("global-settings","Global Settings")
        },
        changeComponentToLanguageSettings(){
            this.changeComponent("language-settings","Language Settings")
        },
        changeComponentToAccessTokenSettings(){
            this.changeComponent("access-token-settings","Access Token")
        },
        changeComponentToReportSettings(){
            this.changeComponent("reports-settings","Report Settings")
        },
        isEnabled(priv) {
         return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
        },
        setUpSystemSettingsTopNav(topNavList){
            for (let sideMenu of topNavList) {
                if('license_expired' in localStorage &&
                 [true, "true"].includes(localStorage.getItem('license_expired')) && sideMenu != "systemInfo"){
                    continue;
                }
            if (sideMenu == "retrieve"){
              let retrieveEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToRetrieveSettings,
                "handler_args":""
            }]
              let retrieve = new SystemSettingsMenu("retrieve", "retrieve", "Retrieve Settings",retrieveEvents)
              retrieve.register()
            }
            if (sideMenu == "license"){
              let licenseEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToLicenseSettings,
                "handler_args":""
            }]
              let license = new SystemSettingsMenu("license", "license", "License",licenseEvents)
              license.register()
            } 
            if (sideMenu == "ingest"){
              let uploadConfigEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToUploadSettings,
                "handler_args":""
            }]
              let upload = new SystemSettingsMenu("ingest", "ingest", "Ingest Settings",uploadConfigEvents)
              upload.register()
            } 
            if (sideMenu == "systemInfo"){
              let systemInfoEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToSystemInfo,
                "handler_args":""
            }]
              let systemInfo = new SystemSettingsMenu("systemInfo", "systemInfo", "System Info",systemInfoEvents)
              systemInfo.register()
            }  
            if (sideMenu == "archive"){
              let archiveEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToarchive,
                "handler_args":""
            }]
              let archive = new SystemSettingsMenu("archive", "archive", "Archive Settings",archiveEvents)
              archive.register()
            }   
            if (sideMenu == "support"){
              let supportEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToSupport,
                "handler_args":""
            }]
              let support = new SystemSettingsMenu("support", "support", "Support",supportEvents)
              support.register()
            } 
            if (sideMenu == "global"){
              let globalEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToGlobalSettings,
                "handler_args":""
            }]
              let global = new SystemSettingsMenu("global", "global", "Global Settings",globalEvents)
              global.register()
            } 
            if (sideMenu == "report"){
              let reportEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToReportSettings,
                "handler_args":""
            }]
              let report = new SystemSettingsMenu("report", "report", "Report Settings",reportEvents)
              report.register()
            }  
            if (sideMenu == "language"){
              let languageEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToLanguageSettings,
                "handler_args":""
            }]
              let language = new SystemSettingsMenu("language", "language", "Language Settings",languageEvents)
              language.register()
            }  
            if (sideMenu == "accessToken"){
              let accessTokenEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToGlobalSettings,
                "handler_args":""
            }]
              let accessToken = new SystemSettingsMenu("accessToken", "accessToken", "Access Token",accessTokenEvents)
              accessToken.register()
            }    
          }
        },
        getEventHandler(eventname,supportedEvents,pluginInfo){
            this.selectedPluginInfo = null;
            if(pluginInfo && Object.prototype.hasOwnProperty.call(pluginInfo,'externalPluginType') 
                && pluginInfo.pluginBundle.js){
                 //load component through bundle
                 Utils.loadPluginBundles([pluginInfo.pluginBundle.js],pluginInfo.componentLoadedEventName).then((event)=>{
                    if(event && Array.isArray(event) && event.length){
                            const loadedInfo = event[0];
                            //register store
                            if(loadedInfo && Object.prototype.hasOwnProperty.call(loadedInfo,'pluginStore') && !this.$store.hasModule(loadedInfo.pluginStore.module)){
                                 this.$store.registerModule(loadedInfo.pluginStore.module,loadedInfo.pluginStore.store); // registers store dynamically at run time
                            }
                            //register route 
                            if(loadedInfo && loadedInfo.settingsRoute && Array.isArray(loadedInfo.settingsRoute)){
                                for(let i = 0; i < loadedInfo.settingsRoute.length;i++){
                                    for(let j = 0; j < loadedInfo.settingsRoute[i].routes.length;j++){
                                        this.$router.addRoute(loadedInfo.settingsRoute[i].parentRouteName,loadedInfo.settingsRoute[i].routes[j]);
                                    }
                                }
                            }
                         //add component dynamically
                         if((!Object.prototype.hasOwnProperty.call(pluginInfo,'registrationType')) || (Object.prototype.hasOwnProperty.call(pluginInfo,'registrationType') && pluginInfo.registrationType == 'add_component')){
                           Utils.loadCssBundle(pluginInfo.pluginBundle.css);
                           this.$options.components[pluginInfo.componentName] = loadedInfo.components[pluginInfo.pluginBundle.incomingComponentName];
                           this.selectedPluginInfo = pluginInfo;
                           this.changeComponent(pluginInfo.componentName,pluginInfo.label);
                        }else{ // if there is a callback then it will call the callback and through callback we can push the component
                          if(Object.prototype.hasOwnProperty.call(pluginInfo,'callback'))
                               pluginInfo.callback(this,pluginInfo); 
                        }
                    }else{ // if event does not have length , means it is empty
                       if(!this.$options.components[pluginInfo.componentName])
                           this.$options.components[pluginInfo.componentName] = pluginInfo.component;
                        this.selectedPluginInfo = pluginInfo;
                        this.changeComponent(pluginInfo.componentName,pluginInfo.label);
                    }
                 })
                return;
            }
            if (pluginInfo){
                if(pluginInfo.label == "Retrieve Settings"){
                    return this.changeComponentToRetrieveSettings()
                }else if(pluginInfo.label == "License"){
                    return this.changeComponentToLicenseSettings()
                }
                else if(pluginInfo.label == "Ingest Settings"){
                    return this.changeComponentToUploadSettings()
                }else if(pluginInfo.label == "System Info"){
                    return this.changeComponentToSystemInfo()
                }else if(pluginInfo.label == "Archive Settings"){
                    return this.changeComponentToarchive()
                }else if(pluginInfo.label == "Support"){
                    return this.changeComponentToSupport()
                }else if(pluginInfo.label == "Report Settings"){
                    return this.changeComponentToReportSettings()
                }else if(pluginInfo.label == "Global Settings"){
                    return this.changeComponentToGlobalSettings()
                }else if(pluginInfo.label == "Language Settings"){
                    return this.changeComponentToLanguageSettings()
                }else if(pluginInfo.label == "Access Token"){
                    return this.changeComponentToAccessTokenSettings()
                }else{
                    this.selectedPluginInfo = Object.assign({}, pluginInfo)
                    return this.changeComponentToExternalPlugin(pluginInfo.label)
                }
            }else{
                let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
                if(event.length != 0){
                    return event[0]["event_handler"]();
                }
            }
        },
        ...mapGetters("registry",["getRegisteredSystemMenus"]),
        ...mapMutations("registry",["registerSystemSettingsMenu","unSetSettingsSidemenu","updateSystemSettingsMenu"]),
    },
     mounted(){
        if('license_expired' in localStorage &&
         [true, 'true'].includes(localStorage.getItem('license_expired'))){
            this.topNavList = ["license"]
            this.activeIndex = "License"
            this.selectedComponent = "license-settings"
        }else{
            this.topNavList = ["retrieve","ingest","systemInfo","global","support", "report"] //"license"
            this.activeIndex = "Retrieve Settings"
            this.selectedComponent = "retrieve-settings"
            if(this.isEnabled('manage-pools')){
                this.topNavList.push('archive')
            }
            if(this.isEnabled('manage-client-access-tokens')){
                this.topNavList.push('accessToken')
            }
            if(this.isEnabled('manage-languages')){
                this.topNavList.push('language')
            }
        }
        this.setUpSystemSettingsTopNav(this.topNavList);
    },

    created(){
        console.log("System settings tabs menu...............", this.getRegisteredSystemMenus());
    }
}
</script>

<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.nav-item{
    color: #9f9f9f !important;
    text-align: start;
    width:100%;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: #22272b;
    color: $active-blue!important;
    border-radius: 10px;
}
.top-nav-bar{
    background: $primary-background;
}

.sidenav{
    height: 100%;
    border-top: none;
    padding:0px !important;
    background: #181b1e;
  .sidebar{
    color: $secondary-text-color;
    min-height: 70px;
    display: flex;
    justify-content: start;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 4px;
    height: 100%;
    border-inline-end: 1px solid #2b2b2b;
    padding: 5px 3px;
    overflow:auto;
    li.sidebar{
      height:40px;
    }
}
li.sidebar:hover{
    color: $text-color;
    font-weight: 500;
    background: $primary-background!important;
}
}

/* width */
::-webkit-scrollbar {
    width: 8px;
    height:3px;
}
/* Track */
::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
}
/* Handle */
::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
}

</style>
